import { useQuery } from 'react-query';

import { getCacheSettings } from 'common/helpers';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getCalculationStatusTypes } from 'modules/_common/api';
import { IReservationStatus } from 'modules/accommodations/features/reservations';

export const useQueryReservationStatus = (enabled: boolean | undefined) => {
  const {
    error: errReservationStatuses,
    data: dataReservationStatuses,
    isLoading: isLoadingReservationStatuses,
  } = useQuery([QUERY_KEYS.RENTALS_CALCULATION_STATUS_TYPE], getCalculationStatusTypes, {
    ...getCacheSettings(),
    enabled: enabled ?? false,
  });

  const selectModel = dataReservationStatuses?.map((item: IReservationStatus) => ({
    value: +item.rootId,
    label: item.label,
    code: item.code,
  }));

  return {
    reservationStatuses: selectModel,
    errReservationStatuses,
    isLoadingReservationStatuses,
  };
};
